import { make } from "vuex-pathify";
interface AlertParams {
  title: string;
}

interface State {
  showAlert: boolean;
  alertParams: AlertParams;
}

const defaultState = () => {
  return {
    showAlert: false,
    alertParams: {
      title: ""
    }
  };
};

const state = defaultState();

const mutations = {
  ...make.mutations(state),
  SET_GLOBAL_ALERT_STATE(state: State, alertParams: AlertParams) {
    state.alertParams = alertParams;
    state.showAlert = true;
  },
  HIDE_GLOBAL_ALERT(state: State) {
    state.showAlert = false;
  }
};

const actions = {
  ...make.actions(state),
  setGlobalAlertState({ commit }: { commit: any }, alertParams: AlertParams) {
    commit("SET_GLOBAL_ALERT_STATE", alertParams);
  },
  hideGlobalAlert({ commit }: { commit: any }) {
    commit("HIDE_GLOBAL_ALERT");
  }
};

const getters = {
  ...make.getters(state),
  showAlert() {
    return state.showAlert;
  },
  alertParams() {
    return state.alertParams;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
